import { ServiceEvent } from "@Light/services/lightTypes";

/** How a service event reads back to the customer once it's been chosen. */
export const formatServiceEvent = (event: ServiceEvent): string =>
  event === ServiceEvent.Switch ? "Provider switch" : "New move-in";
